export type PrizeClaimStatus = {
  canClaim?: boolean;
  canNotClaimReason?: number;
  canNotClaimReasonStr?: string | null;
};

export type PrizeClaimClickAction =
  | { type: "toast"; message: string }
  | { type: "ignore" }
  | { type: "claim" };

/**
 * 领奖组件点击决策。
 * batchWelfareByUid 返回 canClaim=false 且 canNotClaimReasonStr 非空时，直接提示原因，不调领奖接口。
 */
export const resolvePrizeClaimClick = (
  status?: PrizeClaimStatus | null,
): PrizeClaimClickAction => {
  if (!status) {
    return { type: "ignore" };
  }

  const reasonText =
    typeof status.canNotClaimReasonStr === "string"
      ? status.canNotClaimReasonStr.trim()
      : "";

  if (status.canClaim === false && reasonText) {
    return { type: "toast", message: reasonText };
  }

  // 非活动有效期内，且没有原因文案时，点击无效果
  if (!status.canClaim && status.canNotClaimReason === 1) {
    return { type: "ignore" };
  }

  return { type: "claim" };
};
